type ICON_TYPES = {
  colorClass?: string;
  size?: string;
};

export const IconAdd = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z" />
      </svg>
    </i>
  );
};

export const IconAddCircle = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
        />
        <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconArrowBack = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" />
      </svg>
    </i>
  );
};

export const IconArrowDropDownCircle = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM12 15L8 11H16L12 15Z"
        />
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 15L16 11H8L12 15Z" />
      </svg>
    </i>
  );
};

export const IconArrowDropDown = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z" />
      </svg>
    </i>
  );
};

export const IconArrowForward = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" />
      </svg>
    </i>
  );
};

export const IconArrowUpward = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 19V7.82998L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.70998C12.32 4.31998 11.69 4.31998 11.3 4.70998L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.82998V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z" />
      </svg>
    </i>
  );
};

export const IconAutoAwesome = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_196_46)">
          <path d="M22 9L23.25 6.25L26 5L23.25 3.75L22 1L20.75 3.75L18 5L20.75 6.25L22 9Z" />
          <path d="M22 15L20.75 17.75L18 19L20.75 20.25L22 23L23.25 20.25L26 19L23.25 17.75L22 15Z" />
          <path d="M14.5 9.5L12 4L9.5 9.5L4 12L9.5 14.5L12 20L14.5 14.5L20 12L14.5 9.5ZM12.99 12.99L12 15.17L11.01 12.99L8.83 12L11.01 11.01L12 8.83L12.99 11.01L15.17 12L12.99 12.99Z" />
        </g>
        <defs>
          <filter
            id="filter0_d_196_46"
            x="-1"
            y="0"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_196_46"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_196_46"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </i>
  );
};

export const IconBolt = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.14282 13.4855H10.9678L8.59484 22.3999L18.9999 10.5146H12.175L14.5427 1.60013L4.14282 13.4855Z" />
      </svg>
    </i>
  );
};

export const IconBook = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M3 6.71V16.62C4.14 16.21 5.31 16 6.5 16C7.69 16 8.86 16.21 10 16.62V6.72C8.89 6.25 7.7 6 6.5 6C5.28 6 4.11 6.24 3 6.71Z"
        />
        <path d="M19 0.5L14 5.5V15L19 10.5V0.5Z" />
        <path d="M22.47 5.2C22 4.96 21.51 4.76 21 4.59V16.62C19.86 16.21 18.69 16 17.5 16C15.6 16 13.72 16.54 12 17.58V5.48C10.38 4.55 8.51 4 6.5 4C4.71 4 3.02 4.44 1.53 5.2C1.2 5.36 1 5.71 1 6.08V18.16C1 18.74 1.47 19.15 2 19.15C2.16 19.15 2.32 19.11 2.48 19.03C3.69 18.4 5.05 18 6.5 18C8.57 18 10.48 18.82 12 20C13.52 18.82 15.43 18 17.5 18C18.95 18 20.31 18.4 21.52 19.04C21.68 19.12 21.84 19.16 22 19.16C22.52 19.16 23 18.75 23 18.17V6.08C23 5.71 22.8 5.36 22.47 5.2ZM10 16.62C8.86 16.21 7.69 16 6.5 16C5.31 16 4.14 16.21 3 16.62V6.71C4.11 6.24 5.28 6 6.5 6C7.7 6 8.89 6.25 10 6.72V16.62Z" />
      </svg>
    </i>
  );
};

export const IconCard = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM19 19H5C4.45 19 4 18.55 4 18V17H20V18C20 18.55 19.55 19 19 19ZM20 14H4V9C4 8.45 4.45 8 5 8H9.08L7.6 10.02C7.27 10.47 7.37 11.1 7.82 11.42C8.26 11.74 8.89 11.64 9.21 11.2L12 7.4L14.79 11.2C15.11 11.64 15.74 11.74 16.18 11.42C16.63 11.1 16.73 10.47 16.4 10.02L14.92 8H19C19.55 8 20 8.45 20 9V14Z" />
      </svg>
    </i>
  );
};

export const IconCenterDot = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="2" fill="#D77BBA" />
      </svg>
    </i>
  );
};

export const IconCenterSqure = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="10" y="10" width="4" height="4" />
      </svg>
    </i>
  );
};

export const IconCheckBoxOutline = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" />
      </svg>
    </i>
  );
};

export const IconCheckBox = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.71 16.29C10.32 16.68 9.69 16.68 9.3 16.29L5.71 12.7C5.32 12.31 5.32 11.68 5.71 11.29C6.1 10.9 6.73 10.9 7.12 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.71 16.29Z" />
      </svg>
    </i>
  );
};

export const IconClose = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18.3 5.70997C17.91 5.31997 17.28 5.31997 16.89 5.70997L12 10.59L7.10997 5.69997C6.71997 5.30997 6.08997 5.30997 5.69997 5.69997C5.30997 6.08997 5.30997 6.71997 5.69997 7.10997L10.59 12L5.69997 16.89C5.30997 17.28 5.30997 17.91 5.69997 18.3C6.08997 18.69 6.71997 18.69 7.10997 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z" />
      </svg>
    </i>
  );
};

export const IconContentCopy = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.5 20H5.5V7C5.5 6.45 5.05 6 4.5 6C3.95 6 3.5 6.45 3.5 7V20C3.5 21.1 4.4 22 5.5 22H15.5C16.05 22 16.5 21.55 16.5 21C16.5 20.45 16.05 20 15.5 20ZM20.5 16V4C20.5 2.9 19.6 2 18.5 2H9.5C8.4 2 7.5 2.9 7.5 4V16C7.5 17.1 8.4 18 9.5 18H18.5C19.6 18 20.5 17.1 20.5 16ZM18.5 16H9.5V4H18.5V16Z" />
      </svg>
    </i>
  );
};

export const IconCopyRight = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.08 10.86C10.13 10.53 10.24 10.24 10.38 9.99C10.52 9.74 10.72 9.53 10.97 9.37C11.21 9.22 11.51 9.15 11.88 9.14C12.11 9.15 12.32 9.19 12.51 9.27C12.71 9.36 12.89 9.48 13.03 9.63C13.17 9.78 13.28 9.96 13.37 10.16C13.46 10.36 13.5 10.58 13.51 10.8H15.3C15.28 10.33 15.19 9.9 15.02 9.51C14.85 9.12 14.62 8.78 14.32 8.5C14.02 8.22 13.66 8 13.24 7.84C12.82 7.68 12.36 7.61 11.85 7.61C11.2 7.61 10.63 7.72 10.15 7.95C9.67 8.18 9.27 8.48 8.95 8.87C8.63 9.26 8.39 9.71 8.24 10.23C8.09 10.75 8 11.29 8 11.87V12.14C8 12.72 8.08 13.26 8.23 13.78C8.38 14.3 8.62 14.75 8.94 15.13C9.26 15.51 9.66 15.82 10.14 16.04C10.62 16.26 11.19 16.38 11.84 16.38C12.31 16.38 12.75 16.3 13.16 16.15C13.57 16 13.93 15.79 14.24 15.52C14.55 15.25 14.8 14.94 14.98 14.58C15.16 14.22 15.27 13.84 15.28 13.43H13.49C13.48 13.64 13.43 13.83 13.34 14.01C13.25 14.19 13.13 14.34 12.98 14.47C12.83 14.6 12.66 14.7 12.46 14.77C12.27 14.84 12.07 14.86 11.86 14.87C11.5 14.86 11.2 14.79 10.97 14.64C10.72 14.48 10.52 14.27 10.38 14.02C10.24 13.77 10.13 13.47 10.08 13.14C10.03 12.81 10 12.47 10 12.14V11.87C10 11.52 10.03 11.19 10.08 10.86ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconDiscord = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_131_43)">
          <path d="M20.317 4.49197C18.787 3.80197 17.147 3.29197 15.432 3.00197C15.4167 2.99904 15.4009 3.00093 15.3868 3.00738C15.3726 3.01383 15.3608 3.02452 15.353 3.03797C15.143 3.40697 14.909 3.88797 14.745 4.26797C12.9261 3.99621 11.0769 3.99621 9.25799 4.26797C9.07533 3.84683 8.86934 3.4362 8.64099 3.03797C8.63325 3.02436 8.62154 3.01342 8.60743 3.00663C8.59331 2.99984 8.57746 2.99752 8.56199 2.99997C6.84799 3.28997 5.20799 3.79997 3.67699 4.49097C3.66382 4.4965 3.65265 4.50592 3.64499 4.51797C0.532992 9.09297 -0.320008 13.555 0.0989923 17.961C0.100158 17.9718 0.103508 17.9822 0.108837 17.9917C0.114167 18.0011 0.121364 18.0094 0.129992 18.016C1.94638 19.3384 3.97233 20.3458 6.12299 20.996C6.13798 21.0006 6.15402 21.0006 6.16901 20.9959C6.18399 20.9913 6.19723 20.9823 6.20699 20.97C6.66899 20.35 7.08099 19.695 7.43299 19.007C7.45399 18.967 7.43399 18.919 7.39199 18.903C6.746 18.6597 6.12008 18.3661 5.51999 18.025C5.50921 18.0188 5.50012 18.0101 5.49355 17.9995C5.48698 17.989 5.48312 17.977 5.48233 17.9646C5.48153 17.9522 5.48383 17.9398 5.48901 17.9286C5.49418 17.9173 5.50208 17.9075 5.51199 17.9C5.63799 17.807 5.76399 17.71 5.88399 17.613C5.89479 17.6043 5.9078 17.5987 5.92158 17.5969C5.93535 17.5952 5.94934 17.5973 5.96199 17.603C9.88899 19.367 14.142 19.367 18.023 17.603C18.0357 17.5969 18.0498 17.5946 18.0638 17.5961C18.0778 17.5977 18.091 17.6032 18.102 17.612C18.222 17.71 18.347 17.807 18.474 17.9C18.484 17.9073 18.492 17.917 18.4974 17.9282C18.5027 17.9394 18.5052 17.9517 18.5046 17.9641C18.504 17.9765 18.5004 17.9885 18.494 17.9991C18.4876 18.0098 18.4787 18.0186 18.468 18.025C17.87 18.369 17.248 18.66 16.595 18.902C16.585 18.9056 16.5758 18.9114 16.5682 18.9188C16.5606 18.9263 16.5546 18.9353 16.5507 18.9452C16.5468 18.9551 16.5451 18.9658 16.5457 18.9764C16.5463 18.9871 16.5491 18.9975 16.554 19.007C16.914 19.694 17.326 20.348 17.779 20.969C17.7884 20.9817 17.8015 20.9912 17.8166 20.9963C17.8316 21.0013 17.8478 21.0015 17.863 20.997C20.0173 20.3486 22.0466 19.3407 23.865 18.016C23.8739 18.0098 23.8813 18.0017 23.8868 17.9924C23.8923 17.9831 23.8958 17.9727 23.897 17.962C24.397 12.868 23.059 8.44197 20.348 4.51997C20.3413 4.50723 20.3303 4.49729 20.317 4.49197ZM8.01999 15.278C6.83799 15.278 5.86299 14.209 5.86299 12.898C5.86299 11.586 6.81899 10.518 8.01999 10.518C9.22999 10.518 10.196 11.595 10.177 12.898C10.177 14.21 9.22099 15.278 8.01999 15.278ZM15.995 15.278C14.812 15.278 13.838 14.209 13.838 12.898C13.838 11.586 14.793 10.518 15.995 10.518C17.205 10.518 18.171 11.595 18.152 12.898C18.152 14.21 17.206 15.278 15.995 15.278Z" />
        </g>
        <defs>
          <clipPath id="clip0_131_43">
            <rect width={size ? size : "24"} height={size ? size : "24"} />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const IconDocs = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M13 4H6V20H18V9H13V4ZM16 18H8V16H16V18ZM16 12V14H8V12H16Z"
        />
        <path d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" />
      </svg>
    </i>
  );
};

export const IconEdit = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 17.46V20.5C3 20.78 3.22 21 3.5 21H6.54C6.67 21 6.8 20.95 6.89 20.85L17.81 9.94L14.06 6.19L3.15 17.1C3.05 17.2 3 17.32 3 17.46ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" />
      </svg>
    </i>
  );
};

export const IconExp = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width={size ? size : "24"}
          height={size ? size : "24"}
          fill="#B3B3B3"
        />
        <path d="M2.19995 8H7.31449V9.45799H3.72737V11.3094H7.17564V12.7674H3.72737V14.642H7.45335V16.1H2.19995V8Z" />
        <path d="M10.4307 8L11.7961 11.3094H12.0738L13.4393 8H15.094L13.4277 11.9343V12.1425L15.094 16.1H13.4393L12.0738 12.7674H11.7961L10.4307 16.1H8.77601L10.4423 12.1425V11.9343L8.77601 8H10.4307Z" />
        <path d="M17.8978 13.0451V16.1H16.3703V8H19.5409C19.9575 8 20.32 8.06943 20.6286 8.20828C20.9372 8.33943 21.1917 8.51685 21.3923 8.74057C21.6006 8.95657 21.7549 9.20728 21.8552 9.49271C21.9632 9.77042 22.0172 10.0558 22.0172 10.349V10.6267C22.0172 10.9276 21.9632 11.2246 21.8552 11.5177C21.7549 11.8031 21.6006 12.0615 21.3923 12.293C21.1917 12.5167 20.9372 12.698 20.6286 12.8368C20.32 12.9757 19.9575 13.0451 19.5409 13.0451H17.8978ZM17.8978 11.5871H19.3905C19.7299 11.5871 19.996 11.4946 20.1889 11.3094C20.3895 11.1243 20.4898 10.8851 20.4898 10.592V10.4531C20.4898 10.16 20.3895 9.92085 20.1889 9.7357C19.996 9.55056 19.7299 9.45799 19.3905 9.45799H17.8978V11.5871Z" />
      </svg>
    </i>
  );
};

export const IconExpandMore = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.88 9.29L12 13.17L8.11998 9.29C7.72998 8.9 7.09998 8.9 6.70998 9.29C6.31998 9.68 6.31998 10.31 6.70998 10.7L11.3 15.29C11.69 15.68 12.32 15.68 12.71 15.29L17.3 10.7C17.69 10.31 17.69 9.68 17.3 9.29C16.91 8.91 16.27 8.9 15.88 9.29Z" />
      </svg>
    </i>
  );
};

export const IconFloppy = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M5 5V19H19V7.83L16.17 5H5ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18ZM15 10H6V6H15V10Z"
        />
        <path d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z" />
      </svg>
    </i>
  );
};

export const IconHamMenu = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 18H9V16H21V18ZM21 13H3V11H21V13ZM21 8H9V6H21V8Z" />
      </svg>
    </i>
  );
};

export const IconImage = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M5 19H19V5H5V19ZM9 13.14L11.14 15.72L14.14 11.85L18 17H6L9 13.14Z"
        />
        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM14.14 11.86L11.14 15.72L9 13.14L6 17H18L14.14 11.86Z" />
      </svg>
    </i>
  );
};

export const IconInfo = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 7H13V9H11V7ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconInstagram = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.465 1.066C8.638 1.012 9.012 1 12 1C14.988 1 15.362 1.013 16.534 1.066C17.706 1.119 18.506 1.306 19.206 1.577C19.939 1.854 20.604 2.287 21.154 2.847C21.714 3.396 22.146 4.06 22.422 4.794C22.694 5.494 22.88 6.294 22.934 7.464C22.988 8.639 23 9.013 23 12C23 14.988 22.987 15.362 22.934 16.535C22.881 17.705 22.694 18.505 22.422 19.205C22.146 19.9391 21.7133 20.6042 21.154 21.154C20.604 21.714 19.939 22.146 19.206 22.422C18.506 22.694 17.706 22.88 16.536 22.934C15.362 22.988 14.988 23 12 23C9.012 23 8.638 22.987 7.465 22.934C6.295 22.881 5.495 22.694 4.795 22.422C4.06092 22.146 3.39582 21.7133 2.846 21.154C2.28638 20.6047 1.85331 19.9399 1.577 19.206C1.306 18.506 1.12 17.706 1.066 16.536C1.012 15.361 1 14.987 1 12C1 9.012 1.013 8.638 1.066 7.466C1.119 6.294 1.306 5.494 1.577 4.794C1.85372 4.06008 2.28712 3.39531 2.847 2.846C3.39604 2.2865 4.06047 1.85344 4.794 1.577C5.494 1.306 6.294 1.12 7.464 1.066H7.465ZM16.445 3.046C15.285 2.993 14.937 2.982 12 2.982C9.063 2.982 8.715 2.993 7.555 3.046C6.482 3.095 5.9 3.274 5.512 3.425C4.999 3.625 4.632 3.862 4.247 4.247C3.88205 4.60205 3.60118 5.03428 3.425 5.512C3.274 5.9 3.095 6.482 3.046 7.555C2.993 8.715 2.982 9.063 2.982 12C2.982 14.937 2.993 15.285 3.046 16.445C3.095 17.518 3.274 18.1 3.425 18.488C3.601 18.965 3.882 19.398 4.247 19.753C4.602 20.118 5.035 20.399 5.512 20.575C5.9 20.726 6.482 20.905 7.555 20.954C8.715 21.007 9.062 21.018 12 21.018C14.938 21.018 15.285 21.007 16.445 20.954C17.518 20.905 18.1 20.726 18.488 20.575C19.001 20.375 19.368 20.138 19.753 19.753C20.118 19.398 20.399 18.965 20.575 18.488C20.726 18.1 20.905 17.518 20.954 16.445C21.007 15.285 21.018 14.937 21.018 12C21.018 9.063 21.007 8.715 20.954 7.555C20.905 6.482 20.726 5.9 20.575 5.512C20.375 4.999 20.138 4.632 19.753 4.247C19.3979 3.88207 18.9657 3.60121 18.488 3.425C18.1 3.274 17.518 3.095 16.445 3.046ZM10.595 15.391C11.3797 15.7176 12.2534 15.7617 13.0669 15.5157C13.8805 15.2697 14.5834 14.7489 15.0556 14.0422C15.5278 13.3356 15.7401 12.4869 15.656 11.6411C15.572 10.7953 15.197 10.005 14.595 9.405C14.2112 9.02148 13.7472 8.72781 13.2363 8.54515C12.7255 8.36248 12.1804 8.29536 11.6405 8.34862C11.1006 8.40187 10.5792 8.57418 10.1138 8.85313C9.64845 9.13208 9.25074 9.51074 8.9493 9.96185C8.64786 10.413 8.45019 10.9253 8.37052 11.462C8.29084 11.9986 8.33115 12.5463 8.48854 13.0655C8.64593 13.5847 8.91648 14.0626 9.28072 14.4647C9.64496 14.8668 10.0938 15.1832 10.595 15.391ZM8.002 8.002C8.52702 7.47697 9.15032 7.0605 9.8363 6.77636C10.5223 6.49222 11.2575 6.34597 12 6.34597C12.7425 6.34597 13.4777 6.49222 14.1637 6.77636C14.8497 7.0605 15.473 7.47697 15.998 8.002C16.523 8.52702 16.9395 9.15032 17.2236 9.8363C17.5078 10.5223 17.654 11.2575 17.654 12C17.654 12.7425 17.5078 13.4777 17.2236 14.1637C16.9395 14.8497 16.523 15.473 15.998 15.998C14.9377 17.0583 13.4995 17.654 12 17.654C10.5005 17.654 9.06234 17.0583 8.002 15.998C6.94166 14.9377 6.34597 13.4995 6.34597 12C6.34597 10.5005 6.94166 9.06234 8.002 8.002ZM18.908 7.188C19.0381 7.06527 19.1423 6.91768 19.2143 6.75397C19.2863 6.59027 19.3248 6.41377 19.3274 6.23493C19.33 6.05609 19.2967 5.87855 19.2295 5.71281C19.1622 5.54707 19.0624 5.39651 18.936 5.27004C18.8095 5.14357 18.6589 5.04376 18.4932 4.97652C18.3275 4.90928 18.1499 4.87598 17.9711 4.87858C17.7922 4.88119 17.6157 4.91965 17.452 4.9917C17.2883 5.06374 17.1407 5.1679 17.018 5.298C16.7793 5.55103 16.6486 5.88712 16.6537 6.23493C16.6588 6.58274 16.7992 6.91488 17.0452 7.16084C17.2911 7.40681 17.6233 7.54723 17.9711 7.5523C18.3189 7.55737 18.655 7.42669 18.908 7.188Z"
        />
      </svg>
    </i>
  );
};

export const IconKey = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M11.71 10.33C11.01 8.34 9.11 7 7 7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17C9.11 17 11.01 15.66 11.71 13.67L11.94 13H18V17H20V13H22V11H11.94L11.71 10.33ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15Z"
        />
        <path d="M7 5C3.14 5 0 8.14 0 12C0 15.86 3.14 19 7 19C9.72 19 12.17 17.42 13.32 15H16V19H22V15H24V9H13.32C12.17 6.58 9.72 5 7 5ZM22 13H20V17H18V13H11.94L11.71 13.67C11.01 15.66 9.11 17 7 17C4.24 17 2 14.76 2 12C2 9.24 4.24 7 7 7C9.11 7 11.01 8.34 11.71 10.33L11.94 11H22V13ZM7 9C5.35 9 4 10.35 4 12C4 13.65 5.35 15 7 15C8.65 15 10 13.65 10 12C10 10.35 8.65 9 7 9ZM7 13C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11C7.55 11 8 11.45 8 12C8 12.55 7.55 13 7 13Z" />
      </svg>
    </i>
  );
};

export const IconLogout = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11C11.55 21 12 20.55 12 20C12 19.45 11.55 19 11 19H5V5Z" />
        <path d="M20.65 11.65L17.86 8.86003C17.54 8.54003 17 8.76003 17 9.21003V11H10C9.45 11 9 11.45 9 12C9 12.55 9.45 13 10 13H17V14.79C17 15.24 17.54 15.46 17.85 15.14L20.64 12.35C20.84 12.16 20.84 11.84 20.65 11.65Z" />
      </svg>
    </i>
  );
};

export const IconMedium = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_131_44)">
          <path d="M13.5375 12C13.5375 15.7275 10.5075 18.75 6.768 18.75C5.8804 18.7512 5.00125 18.5775 4.18076 18.239C3.36026 17.9004 2.61449 17.4035 1.98603 16.7767C1.35756 16.1499 0.858704 15.4055 0.517941 14.5859C0.177178 13.7663 0.00118111 12.8876 0 12C0 8.27101 3.03 5.25001 6.768 5.25001C7.65573 5.24863 8.53504 5.42214 9.3557 5.76063C10.1764 6.09912 10.9223 6.59596 11.5509 7.22278C12.1796 7.84959 12.6786 8.5941 13.0194 9.41379C13.3603 10.2335 13.5363 11.1123 13.5375 12ZM20.9625 12C20.9625 15.51 19.4475 18.354 17.5785 18.354C15.7095 18.354 14.1945 15.5085 14.1945 12C14.1945 8.49001 15.7095 5.64601 17.5785 5.64601C19.4475 5.64601 20.9625 8.49151 20.9625 12ZM24 12C24 15.144 23.4675 17.6925 22.809 17.6925C22.152 17.6925 21.6195 15.1425 21.6195 12C21.6195 8.85601 22.152 6.30751 22.8105 6.30751C23.4675 6.30751 24 8.85601 24 12Z" />
        </g>
        <defs>
          <clipPath id="clip0_131_44">
            <rect width={size ? size : "24"} height={size ? size : "24"} />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const IconMenu = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z" />
      </svg>
    </i>
  );
};

export const IconMetamask = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.6478 2.67419L13.1525 8.24105L14.5386 4.95668L20.6478 2.67419Z"
          fill="#E2761B"
          stroke="#E2761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.3446 2.67419L10.7796 8.29378L9.46137 4.95668L3.3446 2.67419Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9509 15.5782L15.9547 18.6366L20.2259 19.8117L21.4538 15.646L17.9509 15.5782Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.55359 15.646L3.77393 19.8117L8.04511 18.6366L6.04888 15.5782L2.55359 15.646Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.80404 10.4105L6.61383 12.2109L10.8549 12.3992L10.7042 7.8418L7.80404 10.4105Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.1882 10.4105L13.2504 7.78906L13.1525 12.3992L17.386 12.2109L16.1882 10.4105Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.04517 18.6365L10.5913 17.3936L8.39168 15.6761L8.04517 18.6365Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.4011 17.3936L15.9547 18.6365L15.6007 15.6761L13.4011 17.3936Z"
          fill="#E4761B"
          stroke="#E4761B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.9549 18.6366L13.4012 17.3936L13.6046 19.0584L13.582 19.759L15.9549 18.6366Z"
          fill="#D7C1B3"
          stroke="#D7C1B3"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.04523 18.6366L10.4181 19.759L10.403 19.0584L10.5914 17.3936L8.04523 18.6366Z"
          fill="#D7C1B3"
          stroke="#D7C1B3"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4557 14.5763L8.33142 13.9511L9.83048 13.2656L10.4557 14.5763Z"
          fill="#233447"
          stroke="#233447"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5367 14.5763L14.162 13.2656L15.6686 13.9511L13.5367 14.5763Z"
          fill="#233447"
          stroke="#233447"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.04518 18.6366L8.40677 15.5782L6.04895 15.646L8.04518 18.6366Z"
          fill="#CD6116"
          stroke="#CD6116"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5933 15.5782L15.9548 18.6366L17.9511 15.646L15.5933 15.5782Z"
          fill="#CD6116"
          stroke="#CD6116"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.386 12.2109L13.1525 12.3993L13.5442 14.5763L14.1695 13.2656L15.6761 13.951L17.386 12.2109Z"
          fill="#CD6116"
          stroke="#CD6116"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.33141 13.951L9.838 13.2656L10.4557 14.5763L10.8549 12.3993L6.61389 12.2109L8.33141 13.951Z"
          fill="#CD6116"
          stroke="#CD6116"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.61389 12.2109L8.39167 15.6761L8.33141 13.951L6.61389 12.2109Z"
          fill="#E4751F"
          stroke="#E4751F"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.676 13.951L15.6007 15.6761L17.386 12.2109L15.676 13.951Z"
          fill="#E4751F"
          stroke="#E4751F"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.855 12.3992L10.4557 14.5763L10.9529 17.145L11.0659 13.7627L10.855 12.3992Z"
          fill="#E4751F"
          stroke="#E4751F"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1526 12.3992L12.9492 13.7552L13.0396 17.145L13.5443 14.5763L13.1526 12.3992Z"
          fill="#E4751F"
          stroke="#E4751F"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5443 14.5763L13.0396 17.145L13.4012 17.3936L15.6008 15.6761L15.6761 13.951L13.5443 14.5763Z"
          fill="#F6851B"
          stroke="#F6851B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.33142 13.951L8.39168 15.6761L10.5913 17.3936L10.9529 17.145L10.4557 14.5763L8.33142 13.951Z"
          fill="#F6851B"
          stroke="#F6851B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.582 19.7589L13.6045 19.0584L13.4162 18.8927H10.5763L10.403 19.0584L10.4181 19.7589L8.04523 18.6365L8.87385 19.3145L10.5537 20.4821H13.4388L15.1262 19.3145L15.9548 18.6365L13.582 19.7589Z"
          fill="#C0AD9E"
          stroke="#C0AD9E"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.4011 17.3935L13.0395 17.145H10.9529L10.5913 17.3935L10.403 19.0583L10.5763 18.8926H13.4162L13.6045 19.0583L13.4011 17.3935Z"
          fill="#161616"
          stroke="#161616"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9642 8.60263L21.6045 5.52919L20.6478 2.67419L13.4011 8.05273L16.1883 10.4105L20.128 11.5631L21.0018 10.5461L20.6252 10.2749L21.2278 9.72504L20.7608 9.36346L21.3634 8.90395L20.9642 8.60263Z"
          fill="#763D16"
          stroke="#763D16"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.39545 5.52919L3.03575 8.60263L2.62897 8.90395L3.23161 9.36346L2.77209 9.72504L3.37473 10.2749L2.99808 10.5461L3.86437 11.5631L7.80411 10.4105L10.5913 8.05273L3.3446 2.67419L2.39545 5.52919Z"
          fill="#763D16"
          stroke="#763D16"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.128 11.5631L16.1883 10.4106L17.386 12.211L15.6007 15.6761L17.951 15.646H21.4538L20.128 11.5631Z"
          fill="#F6851B"
          stroke="#F6851B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.80412 10.4106L3.86438 11.5631L2.55365 15.646H6.04894L8.39169 15.6761L6.61391 12.211L7.80412 10.4106Z"
          fill="#F6851B"
          stroke="#F6851B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.1526 12.3992L13.4012 8.05271L14.5462 4.95667H9.46143L10.5914 8.05271L10.855 12.3992L10.9454 13.7702L10.953 17.145H13.0396L13.0546 13.7702L13.1526 12.3992Z"
          fill="#F6851B"
          stroke="#F6851B"
          stroke-width="0.139535"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </i>
  );
};

export const IconMore = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" />
      </svg>
    </i>
  );
};

export const IconOpenInNew = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13V18C19 18.55 18.55 19 18 19ZM14 4C14 4.55 14.45 5 15 5H17.59L8.46 14.13C8.07 14.52 8.07 15.15 8.46 15.54C8.85 15.93 9.48 15.93 9.87 15.54L19 6.41V9C19 9.55 19.45 10 20 10C20.55 10 21 9.55 21 9V4C21 3.45 20.55 3 20 3H15C14.45 3 14 3.45 14 4Z" />
      </svg>
    </i>
  );
};

export const IconOpensea = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_131_41)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 12C24 18.627 18.627 24 12 24C5.37296 24 0 18.627 0 12C0 5.37296 5.37296 0 12 0C18.6284 0 24 5.37296 24 12ZM5.92027 12.4032L5.97206 12.3218L9.09374 7.43836C9.13934 7.36684 9.24662 7.37425 9.28112 7.45191C9.80264 8.6207 10.2526 10.0743 10.0418 10.9792C9.95182 11.3515 9.70526 11.8558 9.42784 12.3218C9.39208 12.3896 9.35264 12.4562 9.31072 12.5203C9.29099 12.5499 9.25771 12.5672 9.22195 12.5672H6.0115C5.9252 12.5672 5.87467 12.4735 5.92027 12.4032ZM19.8346 14.0836V13.3106C19.8346 13.2391 19.7656 13.1873 19.6978 13.2071L16.0472 14.2624C16.0275 14.2673 16.0102 14.2784 15.9967 14.2932C15.6056 14.7252 15.2733 15.0151 15.1853 15.0918L15.1793 15.0971C14.9524 15.2894 14.6713 15.3942 14.3754 15.3942H13.0538V14.0467H14.1042C14.1313 14.0467 14.1572 14.0368 14.1769 14.0195L14.3125 13.895C14.3705 13.842 14.4395 13.7779 14.5221 13.6953C14.5291 13.6883 14.5361 13.6813 14.5433 13.6742C14.5867 13.6309 14.6332 13.5846 14.6787 13.5338C14.733 13.4808 14.786 13.4216 14.8353 13.3636C14.9179 13.2749 14.9968 13.1824 15.0794 13.085C15.1386 13.0209 15.1928 12.9481 15.2458 12.8754C15.305 12.8064 15.363 12.7287 15.4172 12.6547C15.4373 12.6252 15.4587 12.5954 15.4805 12.5649C15.5015 12.5355 15.523 12.5056 15.5442 12.4747C15.5837 12.4155 15.6231 12.3527 15.6564 12.2935C15.7599 12.1332 15.8475 11.9618 15.9215 11.7905C15.9554 11.7172 15.9825 11.64 16.0088 11.565C16.0122 11.5555 16.0155 11.546 16.0189 11.5365C16.0485 11.4489 16.0731 11.3664 16.0916 11.2788C16.136 11.0729 16.1458 10.8683 16.1261 10.6636C16.1212 10.5995 16.1162 10.5366 16.1015 10.4774V10.4676C16.0965 10.4257 16.0867 10.3788 16.0731 10.3357C16.0287 10.1359 15.9597 9.9362 15.8721 9.74017C15.8426 9.66743 15.808 9.59345 15.7747 9.52564C15.6958 9.37895 15.6132 9.23223 15.5195 9.09044C15.5007 9.06046 15.4799 9.03009 15.4592 8.99977C15.4432 8.97647 15.4273 8.95321 15.4123 8.93017C15.3529 8.83856 15.2861 8.75026 15.2213 8.66458C15.2068 8.64531 15.1923 8.62617 15.178 8.60716C15.1398 8.55696 15.0979 8.50676 15.0558 8.45622C15.0328 8.42857 15.0096 8.40081 14.9869 8.37289C14.9228 8.29521 14.86 8.22124 14.7958 8.14852C14.5665 7.88961 14.3261 7.65535 14.1116 7.45564C14.0721 7.41617 14.029 7.37673 13.9846 7.33849C13.8181 7.18687 13.6665 7.05495 13.5395 6.9526C13.5013 6.92317 13.467 6.89419 13.435 6.8672C13.4135 6.84897 13.393 6.83166 13.3731 6.81575C13.334 6.78662 13.3001 6.76082 13.2718 6.73924C13.2546 6.72613 13.2394 6.71458 13.2264 6.70479C13.2165 6.6974 13.2054 6.69247 13.1943 6.68876L13.0538 6.64932V5.48548C13.0538 5.29561 12.9773 5.12548 12.8553 5.00095C12.7332 4.87641 12.5631 4.79999 12.3757 4.79999C12.0009 4.79999 11.6976 5.10697 11.6976 5.48548V6.26959L11.6273 6.24985L11.4362 6.19561L11.2624 6.14753C11.2619 6.14753 11.2614 6.14732 11.2608 6.14708C11.2599 6.14673 11.2589 6.14631 11.2574 6.14631H11.2537L9.93454 5.78876C9.87662 5.77273 9.82728 5.83561 9.85688 5.88863L10.0677 6.27823C10.0797 6.30821 10.0949 6.3382 10.1105 6.36902C10.1206 6.38888 10.1308 6.40908 10.1405 6.42985C10.175 6.49892 10.2095 6.57164 10.2428 6.64439C10.2724 6.70849 10.302 6.77137 10.3365 6.84041C10.351 6.87293 10.3658 6.90584 10.3809 6.93922C10.4359 7.06153 10.4938 7.19014 10.551 7.32865L10.5515 7.32979C10.6006 7.44653 10.6498 7.56329 10.6928 7.68495C10.8111 7.99193 10.9233 8.31988 11.0207 8.65647C11.0449 8.7317 11.0643 8.80452 11.0839 8.87831C11.0923 8.90972 11.1007 8.9413 11.1095 8.97332L11.123 9.03249C11.1625 9.18908 11.197 9.34441 11.2217 9.501C11.2414 9.60825 11.2599 9.71058 11.2698 9.81415C11.2846 9.93127 11.2994 10.0484 11.3043 10.1655C11.3142 10.2728 11.3191 10.385 11.3191 10.4922C11.3191 10.7659 11.2944 11.0298 11.2365 11.2788C11.2329 11.2921 11.2293 11.3056 11.2256 11.3192C11.2094 11.3799 11.1925 11.4428 11.1724 11.5032C11.1541 11.5681 11.1304 11.6329 11.1058 11.7003C11.0972 11.7238 11.0885 11.7477 11.0799 11.772L11.0756 11.7834C11.0573 11.8328 11.0387 11.8831 11.0158 11.9323C10.8937 12.2257 10.7421 12.5179 10.5855 12.7916C10.3562 13.1972 10.1257 13.5535 9.96414 13.7828C9.95431 13.7976 9.94473 13.8116 9.93549 13.8251C9.92387 13.8421 9.91281 13.8582 9.90251 13.874C9.85195 13.9456 9.90374 14.0467 9.99126 14.0467H11.6976V15.3942H9.97155C9.50798 15.3942 9.07894 15.1316 8.87179 14.7112C8.76454 14.5004 8.72262 14.2686 8.74728 14.0417C8.75344 13.9739 8.70288 13.9098 8.63384 13.9098H5.14726C5.08806 13.9098 5.03998 13.9579 5.03998 14.0171V14.0886C5.03998 16.3127 6.8363 18.1152 9.05304 18.1152H15.3075C16.4799 18.1152 17.1456 17.0468 17.7999 15.9967C17.9823 15.704 18.1638 15.4127 18.3552 15.1464C18.6991 14.668 19.5264 14.2883 19.7681 14.1847C19.8075 14.1675 19.8346 14.128 19.8346 14.0836Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_131_41">
            <rect width={size ? size : "24"} height={size ? size : "24"} />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const IconPerson = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" />
      </svg>
    </i>
  );
};

export const IconRadioButtonUnchecked = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconRadioButton = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconRandom = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z" />
      </svg>
    </i>
  );
};

export const IconReceipt = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width="26"
        height="30"
        viewBox="0 0 26 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_155_126)">
          <path d="M15 9H11C10.45 9 10 8.55 10 8C10 7.45 10.45 7 11 7H15C15.55 7 16 7.45 16 8C16 8.55 15.55 9 15 9Z" />
          <path d="M15 12H11C10.45 12 10 11.55 10 11C10 10.45 10.45 10 11 10H15C15.55 10 16 10.45 16 11C16 11.55 15.55 12 15 12Z" />
          <path d="M20.5 3.5L19 2L17.5 3.5L16 2L14.5 3.5L13 2L11.5 3.5L10 2L8.5 3.5L7 2V16H5C4.45 16 4 16.45 4 17V19C4 20.66 5.34 22 7 22H19C20.66 22 22 20.66 22 19V2L20.5 3.5ZM16 20H7C6.45 20 6 19.55 6 19V18H9H13H16V20ZM20 19C20 19.55 19.55 20 19 20C18.45 20 18 19.55 18 19V17C18 16.45 17.55 16 17 16H15H13H9V5H20V19Z" />
          <path d="M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7C17.4477 7 17 7.44772 17 8C17 8.55228 17.4477 9 18 9Z" />
          <path d="M18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12Z" />
        </g>
        <defs>
          <filter
            id="filter0_d_155_126"
            x="-3"
            y="0"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_155_126"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_155_126"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </i>
  );
};

export const IconRemoveCircle = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 12C7 12.55 7.45 13 8 13H16C16.55 13 17 12.55 17 12C17 11.45 16.55 11 16 11H8C7.45 11 7 11.45 7 12ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
      </svg>
    </i>
  );
};

export const IconRemove = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 13H5V11H19V13Z" />
      </svg>
    </i>
  );
};

export const IconRobot = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width="30"
        height="29"
        viewBox="0 0 30 29"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_146_21)">
          <path
            opacity="0.3"
            d="M21 7H9V19H21V7ZM10.5 11.5C10.5 10.67 11.17 10 12 10C12.83 10 13.5 10.67 13.5 11.5C13.5 12.33 12.83 13 12 13C11.17 13 10.5 12.33 10.5 11.5ZM19 17H11V15H19V17ZM18 13C17.17 13 16.5 12.33 16.5 11.5C16.5 10.67 17.17 10 18 10C18.83 10 19.5 10.67 19.5 11.5C19.5 12.33 18.83 13 18 13Z"
          />
          <path d="M19 15H11V17H19V15Z" />
          <path d="M23 9V7C23 5.9 22.1 5 21 5H18C18 3.34 16.66 2 15 2C13.34 2 12 3.34 12 5H9C7.9 5 7 5.9 7 7V9C5.34 9 4 10.34 4 12C4 13.66 5.34 15 7 15V19C7 20.1 7.9 21 9 21H21C22.1 21 23 20.1 23 19V15C24.66 15 26 13.66 26 12C26 10.34 24.66 9 23 9ZM21 19H9V7H21V19Z" />
          <path d="M18 13C18.8284 13 19.5 12.3284 19.5 11.5C19.5 10.6716 18.8284 10 18 10C17.1716 10 16.5 10.6716 16.5 11.5C16.5 12.3284 17.1716 13 18 13Z" />
          <path d="M12 13C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.1716 10 10.5 10.6716 10.5 11.5C10.5 12.3284 11.1716 13 12 13Z" />
        </g>
        <defs>
          <filter
            id="filter0_d_146_21"
            x="-1"
            y="0"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_146_21"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_146_21"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </i>
  );
};

export const IconTicket = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M4.01 8.54C5.2 9.23 6 10.52 6 12C6 13.48 5.19 14.77 4 15.46V18H20V15.46C18.81 14.77 18 13.47 18 12C18 10.53 18.81 9.23 20 8.54V6H4L4.01 8.54ZM10.73 10.22L12 7L13.26 10.23L16.73 10.43L14.04 12.63L14.93 16L12 14.12L9.07 16L9.95 12.63L7.26 10.43L10.73 10.22Z"
        />
        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10V6C22 4.9 21.1 4 20 4ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z" />
      </svg>
    </i>
  );
};

export const IconTime = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4ZM16.25 16.15L11 13V7H12.5V12.25L17 14.92L16.25 16.15Z"
        />
        <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" />
      </svg>
    </i>
  );
};

export const IconTwitter = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M23.643 4.93702C22.808 5.30702 21.911 5.55702 20.968 5.67002C21.941 5.08781 22.669 4.17148 23.016 3.09202C22.1019 3.63501 21.1014 4.01721 20.058 4.22202C19.3564 3.47288 18.4271 2.97634 17.4143 2.80949C16.4016 2.64264 15.3621 2.81481 14.4572 3.29927C13.5524 3.78373 12.8328 4.55338 12.4102 5.48872C11.9875 6.42406 11.8855 7.47277 12.12 8.47202C10.2677 8.37901 8.45564 7.89757 6.80144 7.05892C5.14723 6.22028 3.68785 5.04318 2.51801 3.60402C2.11801 4.29402 1.88801 5.09402 1.88801 5.94602C1.88757 6.71301 2.07644 7.46826 2.43789 8.14475C2.79934 8.82124 3.32217 9.39805 3.96001 9.82402C3.22029 9.80048 2.49688 9.6006 1.85001 9.24102V9.30102C1.84994 10.3768 2.22204 11.4194 2.90319 12.252C3.58434 13.0846 4.53258 13.6559 5.58701 13.869C4.9008 14.0547 4.18135 14.0821 3.48301 13.949C3.78051 14.8746 4.36001 15.684 5.14038 16.2639C5.92075 16.8438 6.86293 17.1652 7.83501 17.183C6.18484 18.4784 4.1469 19.1811 2.04901 19.178C1.67739 19.1781 1.30609 19.1564 0.937012 19.113C3.06649 20.4822 5.54535 21.2088 8.07701 21.206C16.647 21.206 21.332 14.108 21.332 7.95202C21.332 7.75202 21.327 7.55002 21.318 7.35002C22.2293 6.69099 23.0159 5.87491 23.641 4.94002L23.643 4.93702Z" />
      </svg>
    </i>
  );
};

export const IconVideoGame = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width="30"
        height="26"
        viewBox="0 0 30 26"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_196_47)">
          <path d="M24 6H6C4.9 6 4 6.9 4 8V16C4 17.1 4.9 18 6 18H24C25.1 18 26 17.1 26 16V8C26 6.9 25.1 6 24 6ZM24 16H6V8H24V16ZM9 15H11V13H13V11H11V9H9V11H7V13H9V15Z" />
          <path d="M17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5C16 14.3284 16.6716 15 17.5 15Z" />
          <path d="M21.5 12C22.3284 12 23 11.3284 23 10.5C23 9.67157 22.3284 9 21.5 9C20.6716 9 20 9.67157 20 10.5C20 11.3284 20.6716 12 21.5 12Z" />
        </g>
        <defs>
          <filter
            id="filter0_d_196_47"
            x="-1"
            y="0"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_196_47"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_196_47"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </i>
  );
};

export const IconWallet = ({ colorClass, size }: ICON_TYPES) => {
  return (
    <i className={colorClass}>
      <svg
        width={size ? size : "24"}
        height={size ? size : "24"}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 7.28V5C21 3.9 20.1 3 19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V16.72C21.59 16.37 22 15.74 22 15V9C22 8.26 21.59 7.62 21 7.28ZM20 9V15H13V9H20ZM5 19V5H19V7H13C11.9 7 11 7.9 11 9V15C11 16.1 11.9 17 13 17H19V19H5Z" />
        <path d="M16 13.5C16.8284 13.5 17.5 12.8284 17.5 12C17.5 11.1716 16.8284 10.5 16 10.5C15.1716 10.5 14.5 11.1716 14.5 12C14.5 12.8284 15.1716 13.5 16 13.5Z" />
      </svg>
    </i>
  );
};
